// extracted by mini-css-extract-plugin
export var advantages = "advantages-module--advantages--2wVmC";
export var advantagesDesc = "advantages-module--advantages-desc--mMByJ";
export var cardContainer = "advantages-module--card-container--3zqmF";
export var item = "advantages-module--item--2jclC";